import { useContext, useMemo } from 'react'
import classNames from 'classnames'
// components
import { Icon } from 'src/modules/core/components'
// context
import { PaginationContext } from 'src/modules/core/context'

import classes from './pagination.module.scss'

const pagePerScreen = 6

export const Pagination = () => {
  // context
  const { currentPage, numberOfPages, setPage, prevPage, nextPage } = useContext(PaginationContext)
  // memo
  const pages = useMemo(() => Array(pagePerScreen).fill(null), [])

  const handlePageClick = (page: number) => {
    setPage(+page)
  }

  const startingScreenPage = useMemo(() => {
    return Math.floor((currentPage - 1) / pagePerScreen)
  }, [currentPage])

  return (
    <div className={classes.root}>
      <div
        onClick={prevPage}
        className={classNames(classes.paginationButton, {
          [classes.disabled]: currentPage === 1,
        })}
      >
        <Icon
          name="chevronRight"
          className={classNames(classes.arrowLeft, {
            [classes.disabledArrow]: currentPage === 1,
          })}
        />
      </div>
      <div className={classes.pages}>
        {pages.map((_, i) => {
          const page = pagePerScreen * startingScreenPage + i + 1

          return (
            <div
              key={i}
              onClick={() => handlePageClick(page)}
              className={classNames(classes.paginationItem, classes.paginationNumber, {
                [classes.hidden]: page > numberOfPages,
                [classes.currentPage]: page === currentPage,
              })}
            >
              {page}
            </div>
          )
        })}
      </div>
      <div
        onClick={nextPage}
        className={classNames(classes.paginationButton, {
          [classes.disabled]: currentPage === numberOfPages,
        })}
      >
        <Icon
          name="chevronRight"
          className={classNames({
            [classes.disabledArrow]: currentPage === numberOfPages,
          })}
        />
      </div>
    </div>
  )
}
